const posMenu = [
  {
    System: 'POS',
    isActive: true,
    menu: [
      { is_header: true, title: 'نقاط البيـــع', isActive: true },
      {
        path: '/POS/HomePage',
        icon: 'fas fa-home',
        title: 'HomePage',
        isActive: true
      },

      { is_header: true, title: 'الإعدادات', isActive: true },
      {
        path: '/POS/PosSettings',
        icon: 'bi bi-gear',
        title: 'PointOfSaleSettings',
        isActive: true
      },
      {
        path: '/POS/Scale',
        icon: 'bi bi-ticket-perforated',
        title: 'إعدادات الميـزان',
        isActive: true
      },
      {
  path: '/POS/SettlementTypes',
  icon: 'fas fa-layer-group',
  title: 'أنواع التسويـات',
  isActive: true
},
{
  path: '/POS/SettlementPolicy',
  icon: 'fas fa-sliders-h',
  title: 'سيــاسة التسوية',
  isActive: true
},
      // {
      //   path: '/POS/SettlementTypes',
      //   icon: 'bi bi-ui-checks-grid',
      //   title: 'أنواع التسويـات',
      //   isActive: true
      // },
      // {
      //   path: '/POS/SettlementPolicy',
      //   icon: 'bi bi-ui-checks-grid',
      //   title: 'سيــاسة التسوية',
      //   isActive: true
      // },

      { is_header: true, title: 'المبيعات', isActive: true },
      // {
      //   path: '/POS/PosCard',
      //   icon: 'bi bi-bag-check',
      //   title: 'نقـاط البيــع',
      //   isActive: true
      // },
      {
        path: '/POS/Sessions',
        icon: 'bi bi-clock-history',
        title: 'الجلسـات',
        isActive: true
      },
      // {
      //   path: '/POS/Returns',
      //   icon: 'bi bi-arrow-counterclockwise',
      //   title: 'المردودات',
      //   isActive: true
      // },
      // {
      //   path: '/POS/Vouchers',
      //   icon: 'bi bi-ticket-perforated',
      //   title: 'العروض الترويجية',
      //   isActive: true
      // },

      {
        path: '/POS/SessionSettlement',
        icon: 'bi bi-cash-stack',
        title: 'تسوية الجلسـات',
        isActive: true
      },

      {
        path: '/POS/SalesOrdersPos',
        icon: 'bi bi-receipt-cutoff',
        title: 'أوامر البيع (نقاط بيع)',
        isActive: true
      },
      {
        path: '/POS/PosReturns',
        icon: 'bi bi-receipt-cutoff',
        title: 'مردودات نقاط البيع',
        isActive: true
      },

      { is_header: true, title: 'Reports', isActive: true },
      {
        path: '/POS/Reports',
        icon: 'fas fa-chart-bar',
        title: 'Reports',
        isActive: true
      }

      // {
      //   path: 'Pos/Dashboard',
      //   icon: 'bi bi-cpu',
      //   title: 'Dashboard',
      //   isActive: true,
      // },
    ]
  }
];

export default posMenu;
